import { GET_AEM_CONTENT_SUCCESS } from '../../constants';

const initialAEMContentState = {
    loaded: false,
    AEMContent: {
        header: {
            title: null,
        },
        landingPage: {
            title: null,
            content: null,
            imageUrl: null,
        },
        resultPage: {
            title: null,
            content: null,
            titleMulti: null,
            contentMulti: null,
            imageUrl: null,
        },
        allProductsPage: {
            title: null,
            content: null,
        },
        footer: {
            connectionTitle: null,
            connectionContent: null,
            privacyLabel: null,
            privacyUrl: null,
            cobrowseLabel: null,
            cobrowseUrl: null,
            footerDisclosure: null,
        },
        backButtonText: null,
        backButtonLink: null,
    },
};

export default function AEMContentReducer(
    state = initialAEMContentState,
    action,
) {
    switch (action.type) {
        case GET_AEM_CONTENT_SUCCESS: {
            return {
                loaded: true,
                AEMContent: action.AEMContent,
            };
        }
        default:
            return state;
    }
}
